
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { getContractWithdrawalContactPhoneNumber1, getContractWithdrawalContactPhoneNumber2 } from "@/app/utils/EnvConfig";
import RouteName from "@/app/router/NameEnum";

@Component
export default class ContractWithdrawalError extends Vue {
    @Prop({ type: String }) heading!: string;
    @Prop({ type: String }) message!: string;
    private phoneNumber1: string = getContractWithdrawalContactPhoneNumber1();
    private phoneNumber2: string = getContractWithdrawalContactPhoneNumber2();

    private get headingText(): string {
        return this.heading || this.$localize("error.common.title");
    }

    private get messageText(): string {
        return this.message || this.$localize("error.common.message");
    }

    private get showPhoneNumbers(): boolean {
        return this.heading !== undefined && this.message !== undefined && this.heading !== "" && this.message !== "";
    }

    private routeToIdentify(): void {
        this.$router.push({ name: RouteName.CONTRACT_WITHDRAWAL });
    }
}
